export enum EFileEntity {
    Request = 'Request',
    Comment = 'Comment'
}
